import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'components/DropdownButton';
import Icon from 'components/Icon';

const CardActionMenu = ({ items = [], children }) => {
  const actionMenuRef = useRef();

  const itemsRendered = items.map(({ label, attrs = {}, onClick }) => {
    const handleClick = evt => {
      evt.preventDefault();
      actionMenuRef.current.close();
      onClick(evt);
    };
    return (
      <a
        key={label}
        href={`#${label}`}
        className="link-list-item px-3"
        style={{ whiteSpace: 'nowrap' }}
        onClick={onClick ? handleClick : undefined}
        {...attrs}
      >
        <span>{label}</span>
      </a>
    );
  });

  return (
    <DropdownButton
      ref={actionMenuRef}
      buttonClassName="clear subtle-focus borderless circle"
      menuAnchor="right"
      prependIcon={<Icon i={['far', 'ellipsis-v']} />}
      appendIcon={null}
    >
      <div className="link-list py-3">
        {itemsRendered}
        {typeof children === 'function' ? children(actionMenuRef) : children}
      </div>
    </DropdownButton>
  );
};

CardActionMenu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
  })),
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

export default CardActionMenu;
